var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.handleClick}},[(!_vm.isMbRoute())?_c('head-view',{ref:"headViewRef"}):_vm._e(),(_vm.isMbRoute())?_c('mobile-head-view'):_vm._e(),_c('router-view'),(!_vm.isMbRoute())?_c('foot-view'):_vm._e(),(_vm.isMbRoute())?_c('mobile-foot-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }